import React, { Component } from "react";
import PropTypes from "prop-types";
import LoadMask from "Utils/LoadMask/LoadMask";
import {
    RenderDateTime,
    RenderMoneda,
} from "Utils/renderField/renderTableField";
import { RenderCurrency } from "Utils/renderField/renderReadField";
import { activeFormatter } from "Utils/Acciones/Acciones";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { BreakLine, tableOptions } from "Utils/tableOptions";
import { default as GraficaVentas } from "../Grafica";
import Select, { Async } from "react-select";
import { api } from "api";
import { icons } from "icons";
import { PrintContainer, PrintComponent } from "Utils/Print";
import Recibo from "Utils/Recibo";
import ReciboVentaCredito from "Utils/ReciboVentaCredito";
import Factura from "Utils/Factura";
import DatePicker from "Utils/DatePicker";
import moment from "moment";
import {
    tipo_movimientos,
    FACTURADO,
    PROCESO,
    ANULADA,
    ERROR,
} from "variables";
import ListadoPDF from "../../../Utils/ListadoPDF";
import { Link } from "react-router-dom";


import Swal from "sweetalert2";
import { ThermalPrintButton, ThermalStatus } from "../../../ThermalPrint";
import { buildReciboVenta, buildReciboCaja } from "../../../ThermalPrint/buildReciboVenta";

class ListadoVentas extends Component {
    static propTypes = {
        loader: PropTypes.bool.isRequired,
        data: PropTypes.object.isRequired,
        fecha_inicial: PropTypes.string.isRequired,
        fecha_final: PropTypes.string.isRequired,
    };
    constructor(props) {
        super(props);
    }

    // ─── Anular con motivo (igual que en DetalleCaja) ───
    handleAnularVentaMovil = (id) => {
        Swal({
            title: "¿Anular?",
            text: "Ingresa el motivo de la anulación",
            input: "textarea",
            inputAttributes: { autocapitalize: "off" },
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "¡Sí, anular!",
            cancelButtonText: "No, cancelar",
            reverseButtons: true,
            preConfirm: (txtMotivo) => {
                if (!txtMotivo) {
                    Swal.showValidationError("Campo requerido");
                }
            },
        }).then((result) => {
            if (result.value) {
                this.props.anular(id, result.value);
            }
        });
    };

    //ver motivo de error en movil
    verErrorFel = (errores) => {
        Swal({
            title: "Error en la factura",
            text: typeof errores === "string" ? errores : JSON.stringify(errores),
            type: "error",
            confirmButtonText: "Entendido",
        });
    };

    // ─── Fetch de la venta completa + build para impresión térmica ───
    buildDocVenta = (id, tipo) => async () => {
        const resp = await api.get("historial_ventas/reimpresion_venta", {
            id,
            tipo, // "venta" o "recibo_caja"
        });
        if (!resp) return null;
        const builder = tipo === "recibo_caja" ? buildReciboCaja : buildReciboVenta;
        return builder({
            movimiento: resp,
            sucursal: resp.sucursal,
            utiliza_fel: this.props.utiliza_fel,
            conf_tipo_negocio: this.props.conf_tipo_negocio,
        });
    };

    // ─── Badge de estado de factura (misma lógica que la columna "Estado factura") ───
    renderEstadoFacturaVenta = (row) => {
        if (!this.props.utiliza_fel) return null;
        if (row.sin_factura) return <span className="text-muted font-weight-bold">Recibo</span>;

        const cell = row.datos_fel;
        if (cell) {
            const datos_anulacion = !!(cell.datos_anulacion && cell.respuesta_anulacion);
            if (cell.estado_factura == FACTURADO) return <span className="text-success font-weight-bold">Facturada</span>;
            if (cell.estado_factura == PROCESO) return <span className="text-warning font-weight-bold">En proceso</span>;
            if (cell.estado_factura == ANULADA) return <span className="text-danger font-weight-bold">Anulada</span>;
            if (cell.estado_factura == ERROR && datos_anulacion) return <span className="text-danger font-weight-bold">Error en anulación</span>;
            if (cell.estado_factura == ERROR) {
                return (
                    <span className="text-danger font-weight-bold">
                        Error
                        {cell.errores_fel && (
                            <i
                                className="fa fa-eye ml-2"
                                onClick={() => this.verErrorFel(cell.errores_fel)}
                            />
                        )}
                    </span>
                );
            }
            return null;
        }
        if (row.movimiento && row.movimiento.tipo == 30)
            return <span className="text-warning font-weight-bold">Pendiente de facturación</span>;
        return null;
    };

    // ─── Acciones en móvil (térmica + anular con motivo) ───
    renderAccionesVentaMovil = (row) => {
        const {
            estado, utiliza_fel, retimbradoFEL,
            seleccionImpresion, factura_personalizada,
        } = this.props;
        const esVenta = row.movimiento && row.movimiento.tipo === tipo_movimientos.VENTA;
        const esAbono = row.movimiento && row.movimiento.tipo === tipo_movimientos.ABONO_CUENTA;
        const acciones = [];

        // Vista de anulados: solo "Ver" para ventas
        if (!estado) {
            if (esVenta) {
                acciones.push(
                    <Link key="ver" to={`/reporte_ventas/${row.id}`} className="dm-btn-accion dm-btn-accion--ver">
                        <i className="fa fa-eye" /> Ver
                    </Link>
                );
            }
            return acciones.length ? <div className="dm-acciones-lista">{acciones}</div> : null;
        }

        // Vista de activos
        if (esVenta) {
            const timbrado = row.datos_fel ? !!(row.datos_fel.uuid || row.datos_fel.numero || row.datos_fel.serie) : false;
            const datos_anulacion = row.datos_fel ? !!(row.datos_fel.datos_anulacion && row.datos_fel.respuesta_anulacion) : false;
            const impresion_recibo_caja = row.movimiento ? (row.movimiento.tipo_pago == 200 || row.movimiento.tipo == 80) : false;

            acciones.push(
                <Link key="ver" to={`/reporte_ventas/${row.id}`} className="dm-btn-accion dm-btn-accion--ver">
                    <i className="fa fa-eye" /> Ver
                </Link>
            );
            acciones.push(
                <button key="reimprimir" type="button" className="dm-btn-accion dm-btn-accion--print"
                    onClick={() => seleccionImpresion(row.id, "reporteVentasReimpresion")}>
                    <i className="fa fa-print" />{" "}
                    Reimprimir {factura_personalizada || utiliza_fel ? "factura" : "recibo"}
                </button>
            );
            acciones.push(
                <ThermalPrintButton
                    key="reimprimir-bt"
                    buildDoc={this.buildDocVenta(row.id, "venta")}
                    label="Reimprimir BT"
                    className="dm-btn-accion dm-btn-accion--print"
                />
            );
            if (impresion_recibo_caja) {
                acciones.push(
                    <ThermalPrintButton
                        key="recibo-caja-bt"
                        buildDoc={this.buildDocVenta(row.id, "recibo_caja")}
                        label="Recibo de caja BT"
                        className="dm-btn-accion dm-btn-accion--print"
                    />
                );
                acciones.push(
                    <button key="recibo-caja" type="button" className="dm-btn-accion dm-btn-accion--print"
                        onClick={() => seleccionImpresion(row.id, "reporteVentasReimpresionReciboCaja")}>
                        <i className="fa fa-print" /> Recibo de caja
                    </button>
                );
            }
            if (utiliza_fel && !timbrado && !datos_anulacion && !row.sin_factura) {
                acciones.push(
                    <button key="retimbrar" type="button" className="dm-btn-accion dm-btn-accion--fel"
                        onClick={() => retimbradoFEL(row.id)}>
                        <i className="fa fa-file-text-o" /> Retimbrar factura
                    </button>
                );
            }
            if (row.caja_activa) {
                acciones.push(
                    <button key="anular" type="button" className="dm-btn-accion dm-btn-accion--anular"
                        onClick={() => this.handleAnularVentaMovil(row.id)}>
                        <i className="fa fa-ban" /> Anular
                    </button>
                );
            }
        } else if (esAbono) {
            acciones.push(
                <button key="recibo-caja" type="button" className="dm-btn-accion dm-btn-accion--print"
                    onClick={() => seleccionImpresion(row.id, "reporteVentasReimpresionReciboCaja")}>
                    <i className="fa fa-print" /> Recibo de caja
                </button>
            );
            acciones.push(
                <ThermalPrintButton
                    key="recibo-caja-bt"
                    buildDoc={this.buildDocVenta(row.id, "recibo_caja")}
                    label="Reimprimir BT"
                    className="dm-btn-accion dm-btn-accion--print"
                />
            );
            acciones.push(
                <button key="anular" type="button" className="dm-btn-accion dm-btn-accion--anular"
                    onClick={() => this.handleAnularVentaMovil(row.id)}>
                    <i className="fa fa-ban" /> Anular
                </button>
            );
        } else {
            acciones.push(
                <button key="anular" type="button" className="dm-btn-accion dm-btn-accion--anular"
                    onClick={() => this.handleAnularVentaMovil(row.id)}>
                    <i className="fa fa-ban" /> Anular
                </button>
            );
        }

        return acciones.length ? <div className="dm-acciones-lista">{acciones}</div> : null;
    };

    // ─── Tarjeta de una venta (móvil) ───
    renderTarjetaVentaMovil = (row) => {
        const { estado, conf_ventas_al_credito, utiliza_fel } = this.props;
        const tieneFel = utiliza_fel && row.datos_fel;
        const tipoMov = row.movimiento ? row.movimiento.tipo_movimiento : "";

        return (
            <div className={`dm-card ${!estado ? "dm-card--anulado" : ""}`} key={row.id}>
                <div className="dm-card-header">
                    <RenderDateTime fecha={row.creado} />
                    <span className="dm-tipo">{tipoMov}</span>
                </div>

                <div className="dm-cell">
                    <span className="dm-label">Código</span>
                    <span className="dm-value">
                        {tipoMov} {row.codigo || ""} {this.renderEstadoFacturaVenta(row)}
                    </span>
                </div>

                {row.movimiento && row.movimiento.concepto && (
                    <div className="dm-cell">
                        <span className="dm-label">Nota</span>
                        <span className="dm-value">{row.movimiento.concepto}</span>
                    </div>
                )}

                <div className="dm-cell">
                    <span className="dm-label">Comprador</span>
                    <span className="dm-value">{row.cliente || "—"}</span>
                </div>

                {row.mostrador && (
                    <div className="dm-cell">
                        <span className="dm-label">Vendedor</span>
                        <span className="dm-value">{row.mostrador}</span>
                    </div>
                )}
                {row.usuario && (
                    <div className="dm-cell">
                        <span className="dm-label">Cajero</span>
                        <span className="dm-value">{row.usuario}</span>
                    </div>
                )}

                {tieneFel && row.datos_fel.serie && (
                    <div className="dm-cell">
                        <span className="dm-label">Serie</span>
                        <span className="dm-value">{row.datos_fel.serie}</span>
                    </div>
                )}
                {tieneFel && row.datos_fel.numero && (
                    <div className="dm-cell">
                        <span className="dm-label">Número</span>
                        <span className="dm-value">{row.datos_fel.numero}</span>
                    </div>
                )}
                {tieneFel && row.datos_fel.fechaCertificacion && (
                    <div className="dm-cell">
                        <span className="dm-label">Fecha factura</span>
                        <span className="dm-value"><RenderDateTime fecha={row.datos_fel.fechaCertificacion} /></span>
                    </div>
                )}

                {row.referencia && (
                    <div className="dm-cell">
                        <span className="dm-label">Referencia</span>
                        <span className="dm-value">{row.referencia}</span>
                    </div>
                )}

                {!estado && row.anulado_por && (
                    <div className="dm-cell">
                        <span className="dm-label">Anulado por</span>
                        <span className="dm-value">{row.anulado_por}</span>
                    </div>
                )}

                {conf_ventas_al_credito && (
                    <div className="dm-cell">
                        <span className="dm-label">Fecha crédito</span>
                        <span className="dm-value">
                            {row.cuenta_cobrar
                                ? <RenderDateTime fecha={row.cuenta_cobrar.creado} />
                                : "Sin Registro"}
                        </span>
                    </div>
                )}

                {conf_ventas_al_credito && row.cuenta_cobrar && (
                    <div className="dm-cell">
                        <span className="dm-label">Saldo crédito</span>
                        <span className="dm-value"><RenderMoneda monto={row.cuenta_cobrar.saldo} /></span>
                    </div>
                )}

                <div className="dm-cell dm-cell--total">
                    <span className="dm-label">Pago de</span>
                    <span className="dm-value">
                        <RenderMoneda monto={row.movimiento ? row.movimiento.total_cobrar_pagar : 0} />
                    </span>
                </div>

                {this.renderAccionesVentaMovil(row)}
            </div>
        );
    };

    // ─── Paginación móvil (misma que en la caja) ───
    getPaginasVentasMovil = (actual, total) => {
        const delta = 2;
        const range = [];
        for (let i = Math.max(1, actual - delta); i <= Math.min(total, actual + delta); i++) range.push(i);
        if (range[0] > 1) {
            if (range[0] > 2) range.unshift("...");
            range.unshift(1);
        }
        if (range[range.length - 1] < total) {
            if (range[range.length - 1] < total - 1) range.push("...");
            range.push(total);
        }
        return range;
    };

    renderPaginacionVentasMovil = (sizePerPage) => {
        const { data, page, listar } = this.props;
        const total = data ? data.count : 0;
        const size = sizePerPage || 10;
        const totalPages = Math.ceil(total / size);
        if (totalPages <= 1) return null;

        const actual = page || 1;
        const paginas = this.getPaginasVentasMovil(actual, totalPages);

        return (
            <ul className="pagination dm-pagination">
                <li className={`page-item ${actual <= 1 ? "disabled" : ""}`}>
                    <a className="page-link" onClick={() => actual > 1 && listar(actual - 1)}>«</a>
                </li>
                {paginas.map((p, idx) =>
                    p === "..." ? (
                        <li key={`dots-${idx}`} className="page-item disabled"><span className="page-link">…</span></li>
                    ) : (
                        <li key={p} className={`page-item ${p === actual ? "active" : ""}`}>
                            <a className="page-link" onClick={() => listar(p)}>{p}</a>
                        </li>
                    )
                )}
                <li className={`page-item ${actual >= totalPages ? "disabled" : ""}`}>
                    <a className="page-link" onClick={() => actual < totalPages && listar(actual + 1)}>»</a>
                </li>
            </ul>
        );
    };

    componentWillMount() {
        this.props.listar(this.props.page);
    }

    render() {
        // state
        const {
            loader,
            data,
            fecha_inicial,
            fecha_final,
            estado,
            conf_ventas_al_credito,
            factura_personalizada,
            venta_impresion,
            recibo_caja_impresion,
            formato_factura,
            datos_venta,
            utiliza_fel,
            estado_descarga,
            estado_descarga_simple,
            estado_factura,
            filtro_fecha,
            search,
            conf_tipo_negocio,
            data_movimientos_caja,
        } = this.props;
        // bind
        const {
            anular,
            estadoChange,
            seleccionImpresion,
            retimbradoFEL,
            print_state,
            descargarListado,
            descargarListadoSimple,
            estadoFacturaChange,
            filtroFechaChange,
            buscar,
            permiso_grafica_ventas,
            impresionGeneral,
        } = this.props;
        const options = _.cloneDeep(tableOptions);

        const getUsuarios = (search) => {
            return api
                .get("historial_ventas/usuarios", { search })
                .catch(() => {})
                .then((data) => {
                    return { options: data };
                });
        };

        const getCliente = (search) => {
            return api
                .get("clientes", { search })
                .catch(() => {})
                .then((data) => {
                    return { options: data.results };
                });
        };

        options.noDataText = loader ? "Cargando..." : options.noDataText;
        options.page = this.props.page;
        options.onPageChange = this.props.listar;
        options.onSortChange = this.props.sortChange;

        const accionesReciboFactura = (id, data) => {
            const timbrado = data.datos_fel
                ? data.datos_fel.uuid ||
                  data.datos_fel.numero ||
                  data.datos_fel.serie
                    ? true
                    : false
                : false;
            const datos_anulacion = data.datos_fel
                ? data.datos_fel.datos_anulacion &&
                  data.datos_fel.respuesta_anulacion
                    ? true
                    : false
                : false;
            const impresion_recibo_caja = data.movimiento
                ? data.movimiento.tipo_pago == 200 || data.movimiento.tipo == 80
                    ? true
                    : false
                : false;
            return (
                <span>
                    <img
                        onClick={(e) => {
                            e.preventDefault();
                            seleccionImpresion(id, "reporteVentasReimpresion");
                        }}
                        className="action-img"
                        title={`Reimprimir ${
                            factura_personalizada || utiliza_fel
                                ? "factura"
                                : "recibo"
                        }`}
                        src={utiliza_fel ? icons.fel : icons.recibo}
                        alt={`Reimprimir ${
                            factura_personalizada ? "factura" : "recibo"
                        }`}
                        style={{ maxWidth: "22px" }}
                    />
                    <ThermalPrintButton
                        buildDoc={this.buildDocVenta(id, "venta")}
                        label=""
                        title="Reimprimir venta en térmica"
                        className="btn btn-sm btn-info ml-1"
                    />
                    {impresion_recibo_caja && (
                        <ThermalPrintButton
                            buildDoc={this.buildDocVenta(id, "recibo_caja")}
                            label=""
                            title="Recibo de caja en térmica"
                            className="btn btn-sm btn-info ml-1"
                        />
                    )}
                    {impresion_recibo_caja && (
                        <img
                            onClick={(e) => {
                                e.preventDefault();
                                seleccionImpresion(
                                    id,
                                    "reporteVentasReimpresionReciboCaja"
                                );
                            }}
                            className="action-img"
                            title="Reimprimir recibo de caja"
                            src={icons.recibo_caja}
                            alt="Reimprimir recibo de caja"
                            style={{ maxWidth: "22px" }}
                        />
                    )}
                    {utiliza_fel && !timbrado && !datos_anulacion && !data.sin_factura && (
                        <img
                            onClick={(e) => {
                                e.preventDefault();
                                retimbradoFEL(id);
                            }}
                            className="action-img"
                            title="Retimbrar factura"
                            src={icons.timbrar_factura}
                            alt="Retimbrar factura"
                            style={{ maxWidth: "22px" }}
                        />
                    )}
                </span>
            );
        };

        const accionReciboCaja = (id) => {
            if (!id) return "";
            return (
                <span>
                    <img
                        onClick={(e) => {
                            e.preventDefault();
                            seleccionImpresion(id, "reporteVentasReimpresionReciboCaja");
                        }}
                        className="action-img"
                        title="Reimprimir recibo de caja"
                        src={icons.recibo}
                        alt="Reimprimir recibo de caja"
                        style={{ maxWidth: "22px" }}
                    />
                    <ThermalPrintButton
                        buildDoc={this.buildDocVenta(id, "recibo_caja")}
                        label="BT"
                        className="btn btn-sm btn-info ml-1"
                    />
                </span>
            );
        };

        const estados_factura = [
            { value: 10, label: "En proceso" },
            { value: 20, label: "Facturada" },
            { value: 30, label: "Anulada" },
            { value: 40, label: "Error" },
            { value: 50, label: "Pendiente de facturación" },
        ];

        return (
            <div>
                {print_state.flag && <PrintComponent />}
                {permiso_grafica_ventas && <GraficaVentas />}
                <div className="row mb-2">
                    <div className="col-12">
                        <div className="grid-container">
                            <div className="padding-15 d-flex flex-column flex-sm-column mb-1">
                                <div style={{ flex: "1" }}>
                                    <h3>
                                        <b>Historial de ventas</b>
                                    </h3>
                                </div>
                                <div
                                    className="d-flex flex-wrap flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row justify-content-start"
                                    style={{ flex: "3" }}
                                >
                                    {utiliza_fel && (
                                        <div className="flex2">
                                            <label>Filtrar por</label>
                                            <div className="d-flex flex-column">
                                                <div className="d-flex flex-row">
                                                    <div className="radio c-radio c-radio-nofont d-flex ml-10">
                                                        <label className="negro-dark2 font-weight-normal">
                                                            <input
                                                                name="filtro_fecha"
                                                                type="radio"
                                                                value="true"
                                                                checked={
                                                                    filtro_fecha ===
                                                                    "fecha_venta"
                                                                }
                                                                onChange={() => {
                                                                    filtroFechaChange(
                                                                        "fecha_venta"
                                                                    );
                                                                }}
                                                            />
                                                            <span />
                                                            Fecha venta
                                                        </label>
                                                    </div>
                                                    <div className="radio c-radio c-radio-nofont d-flex ml-10">
                                                        <label className="negro-dark2 font-weight-normal">
                                                            <input
                                                                name="filtro_fecha"
                                                                type="radio"
                                                                value="false"
                                                                checked={
                                                                    filtro_fecha ===
                                                                    "fecha_facturacion"
                                                                }
                                                                onChange={() => {
                                                                    filtroFechaChange(
                                                                        "fecha_facturacion"
                                                                    );
                                                                }}
                                                            />
                                                            <span />
                                                            Fecha facturación
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="mb-2 mr-md-2" style={{ flex: 1 }}>
                                        <label>Fecha Inicio</label>
                                        <DatePicker
                                            value={fecha_inicial}
                                            maxDate={new Date()}
                                            onChange={(date) => {
                                                this.props.setFecha(
                                                    "Inicial",
                                                    date
                                                );
                                            }}
                                        />
                                    </div>

                                    <div className="mb-2 mr-md-2" style={{ flex: 1 }}>
                                        <label>Fecha Fin</label>
                                        <DatePicker
                                            value={fecha_final}
                                            minDate={
                                                new Date(
                                                    moment(
                                                        fecha_inicial,
                                                        "YYYY-MM-DD"
                                                    )
                                                )
                                            }
                                            onChange={(date) => {
                                                this.props.setFecha(
                                                    "Final",
                                                    date
                                                );
                                            }}
                                        />
                                    </div>

                                    <div className="mb-2 mr-md-2" style={{ flex: 1 }}>
                                        <label>Vendedor</label>
                                        <Async
                                            className="form-control"
                                            labelKey="first_name"
                                            valueKey="id"
                                            searchPromptText="Escriba para buscar"
                                            loadOptions={getUsuarios}
                                            placeholder={"Vendedor"}
                                            onChange={(e) => {
                                                this.props.setUsuario(e);
                                            }}
                                            value={this.props.usuario}
                                        />
                                    </div>

                                    <div className="mb-2 mr-md-2" style={{ flex: 1 }}>
                                        <label>Cliente</label>
                                        <Async
                                            className="form-control"
                                            labelKey="nombre"
                                            valueKey="id"
                                            searchPromptText="Escriba para buscar"
                                            loadOptions={getCliente}
                                            placeholder={"Cliente"}
                                            onChange={(e) => {
                                                this.props.setCliente(e);
                                            }}
                                            value={this.props.cliente}
                                        />
                                    </div>
                                </div>
                                <div
                                    className="d-flex flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row justify-content-start"
                                    style={{ flex: "3" }}
                                >
                                    <div className="mt-10">
                                        <label htmlFor="estado">Estado</label>
                                        <div className="d-flex flex-column">
                                            <div className="d-flex flex-row">
                                                <div className="radio c-radio c-radio-nofont d-flex ml-10">
                                                    <label className="negro-dark2 font-weight-normal">
                                                        <input
                                                            name="estado"
                                                            type="radio"
                                                            value="true"
                                                            checked={
                                                                estado === true
                                                            }
                                                            onChange={() => {
                                                                estadoChange(
                                                                    true
                                                                );
                                                            }}
                                                        />
                                                        <span />
                                                        Activo
                                                    </label>
                                                </div>
                                                <div className="radio c-radio c-radio-nofont d-flex ml-10">
                                                    <label className="negro-dark2 font-weight-normal">
                                                        <input
                                                            name="estado"
                                                            type="radio"
                                                            value="false"
                                                            checked={
                                                                estado === false
                                                            }
                                                            onChange={() => {
                                                                estadoChange(
                                                                    false
                                                                );
                                                            }}
                                                        />
                                                        <span />
                                                        Anulado
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    &nbsp; &nbsp;
                                    {utiliza_fel && (
                                        <div className="mt-10 col-12 col-md-3 col-lg-2">
                                            <label>Estado Factura</label>
                                            <div>
                                                <Select
                                                    isClearable
                                                    placeholder="Seleccionar"
                                                    className="form-control"
                                                    options={estados_factura}
                                                    valueKey="value"
                                                    labelKey="label"
                                                    value={estado_factura}
                                                    onChange={(e) => {
                                                        estadoFacturaChange(
                                                            e ? e.value : ""
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    &nbsp; &nbsp;
                                    {utiliza_fel && (
                                        <div className="mt-10 col-12 col-md-4 col-lg-3">
                                            <label>Buscar Factura</label>
                                            <div
                                                className="w-100"
                                                style={{
                                                    position: "relative",
                                                }}
                                            >
                                                <input
                                                    id="buscar"
                                                    type="text"
                                                    name="buscar"
                                                    placeholder="Ingrese número o serie"
                                                    ref={(node) => {
                                                        this.buscar = node;
                                                        if (this.buscar) {
                                                            this.buscar.value = search;
                                                        }
                                                    }}
                                                    // onKeyPress={(e) => {
                                                    //     if (e.key === "Enter") {
                                                    //         e.preventDefault();
                                                    //         if (
                                                    //             this.buscar
                                                    //                 .value
                                                    //         ) {
                                                    //             buscar(
                                                    //                 this.buscar
                                                    //                     .value
                                                    //             );
                                                    //         }
                                                    //     }
                                                    // }}
                                                    onChange={() => {
                                                        if (this.buscar) {
                                                            buscar(
                                                                this.buscar
                                                                    .value
                                                            );
                                                        }
                                                    }}
                                                    autoComplete="off"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <LoadMask loading={loader} light blur>
                                <div className="d-flex flex-column flex-md-row flex-wrap content-total-reports w-100 mt-10">
                                  <button
                                        
                                        className="btn btn-secondary mb-2 mb-md-0 mr-md-2 align-self-stretch align-self-md-center"
                                        disabled={estado_descarga_simple}
                                        onClick={() => {
                                            descargarListadoSimple();
                                        }}
                                    >
                                        <em
                                            className={`fa ${
                                                estado_descarga_simple
                                                    ? "fa-spinner fa-pulse"
                                                    : "fa-download"
                                            }`}
                                        ></em>
                                        &nbsp;Descargar Listado
                                    </button>
                                    <button
                                        className="btn btn-secondary mb-2 mb-md-0 mr-md-2 align-self-stretch align-self-md-center"
                                        disabled={estado_descarga}
                                        onClick={() => {
                                            descargarListado();
                                        }}
                                    >
                                        <em
                                            className={`fa ${
                                                estado_descarga
                                                    ? "fa-spinner fa-pulse"
                                                    : "fa-download"
                                            }`}
                                        ></em>
                                        &nbsp;Descargar Listado Detallado
                                    </button>
                                    <button
                                        className="btn btn-secondary mb-2 mb-md-0 mr-md-2 align-self-stretch align-self-md-center"
                                        onClick={() => {
                                            impresionGeneral(
                                                0,
                                                "impresionGeneral"
                                            );
                                        }}
                                    >
                                        &nbsp;Imprimir PDF General
                                    </button>
                                    <div className="d-flex flex-row justify-content-between justify-content-md-end align-items-center w-100 mt-2 mt-md-0">
                                        <h3 className="padding-10 margin-0">
                                            <b>Total</b>
                                        </h3>
                                        <h3 className="padding-10 margin-0">
                                            <b>
                                                <RenderCurrency
                                                    value={
                                                        data.total
                                                            ? data.total
                                                            : 0
                                                    }
                                                />
                                            </b>
                                        </h3>
                                    </div>
                                    <div className="d-flex justify-content-center justify-content-md-end mt-2 mb-1 px-2">
                                        <ThermalStatus />
                                    </div>
                                </div>
                                {/* ---- MÓVIL: tarjetas ---- */}
                                <div className="detalle-mov-cards">
                                    {(loader ? [] : (data.results || [])).length === 0 ? (
                                        <div className="dm-vacio">{loader ? "Cargando..." : "No hay ventas"}</div>
                                    ) : (
                                        (data.results || []).map((row) => this.renderTarjetaVentaMovil(row))
                                    )}
                                    {this.renderPaginacionVentasMovil(options.sizePerPage)}
                                </div>

                                {/* ---- ESCRITORIO: tabla ---- */}
                                <div className="detalle-mov-tabla">
                                <BootstrapTable
                                    data={loader ? [] : data.results}
                                    remote
                                    pagination
                                    hover
                                    fetchInfo={{ dataTotalSize: data.count }}
                                    options={options}
                                >
                                    <TableHeaderColumn
                                        dataSort
                                        dataField="creado"
                                        tdStyle={BreakLine}
                                        thStyle={BreakLine}
                                        dataFormat={(cell, row) => {
                                            return (
                                                <RenderDateTime fecha={cell} />
                                            );
                                        }}
                                    >
                                        Fecha venta
                                    </TableHeaderColumn>
                                    {utiliza_fel && (
                                        <TableHeaderColumn
                                            dataSort
                                            dataField="fel__fechaCertificacion"
                                            tdStyle={BreakLine}
                                            thStyle={BreakLine}
                                            dataFormat={(cell, row) => {
                                                if (!row.datos_fel) {
                                                    return "";
                                                }
                                                return (
                                                    <RenderDateTime
                                                        fecha={
                                                            row.datos_fel
                                                                .fechaCertificacion
                                                        }
                                                    />
                                                );
                                            }}
                                        >
                                            Fecha facturación
                                        </TableHeaderColumn>
                                    )}
                                    {/*----------- CONFIGURACION DE VENTAS AL CREDITO -----------*/}
                                    {conf_ventas_al_credito &&
                                    <TableHeaderColumn
                                        dataSort
                                        dataField="cuenta_cobrar__creado"
                                        tdStyle={BreakLine}
                                        thStyle={BreakLine}
                                        dataFormat={(cell, row) => {
                                            if (row.cuenta_cobrar) {
                                                return (
                                                    <RenderDateTime
                                                        fecha={
                                                            row.cuenta_cobrar
                                                                .creado
                                                        }
                                                    />
                                                );
                                            } else {
                                                return (
                                                    <span>Sin Registro</span>
                                                );
                                            }
                                        }}
                                    >
                                        Fecha crédito
                                    </TableHeaderColumn>
                                    }
                                    <TableHeaderColumn
                                        dataField="mostrador"
                                        tdStyle={BreakLine}
                                        thStyle={BreakLine}
                                        // dataFormat={(cell, row) => {
                                        //     return row.usuario;
                                        // }}
                                    >
                                        Vendedor
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataSort
                                        dataField="usuario__first_name"
                                        tdStyle={BreakLine}
                                        thStyle={BreakLine}
                                         dataFormat={(cell, row) => {
                                            return row.usuario;
                                        }}
                                    >
                                        Cajero
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataSort
                                        dataField="codigo"
                                        tdStyle={BreakLine}
                                        thStyle={BreakLine}
                                        dataFormat={(cell, row) => {
                                            return (
                                                <span>
                                                    {
                                                        row.movimiento
                                                            .tipo_movimiento
                                                    }{" "}
                                                    {row && row.codigo ?  row.codigo : ""}
                                                </span>
                                            );
                                        }}
                                    >
                                        Código
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        datasort
                                        dataField="movimiento__concepto"
                                        tdStyle={BreakLine}
                                        thStyle={BreakLine}
                                        dataFormat={(cell, row) => {
                                            return row.movimiento.concepto;
                                        }}
                                    >
                                        Nota
                                    </TableHeaderColumn>
                                    {utiliza_fel && (
                                        <TableHeaderColumn
                                            dataField="datos_fel"
                                            tdStyle={BreakLine}
                                            thStyle={BreakLine}
                                            dataFormat={(cell, row) => {
                                                if (row.datos_fel) {
                                                    return (
                                                        <span>
                                                            {row.datos_fel
                                                                .numero
                                                                ? row.datos_fel
                                                                      .numero
                                                                : ""}
                                                        </span>
                                                    );
                                                } else {
                                                    return <span></span>;
                                                }
                                            }}
                                        >
                                            Número
                                        </TableHeaderColumn>
                                    )}
                                    {utiliza_fel && (
                                        <TableHeaderColumn
                                            dataField="datos_fel"
                                            tdStyle={BreakLine}
                                            thStyle={BreakLine}
                                            dataFormat={(cell, row) => {
                                                if (row.datos_fel) {
                                                    return (
                                                        <span>
                                                            {row.datos_fel.serie
                                                                ? row.datos_fel
                                                                      .serie
                                                                : ""}
                                                        </span>
                                                    );
                                                } else {
                                                    return <span></span>;
                                                }
                                            }}
                                        >
                                            Serie
                                        </TableHeaderColumn>
                                    )}
                                    {utiliza_fel && (
                                        <TableHeaderColumn
                                            dataField="datos_fel"
                                            tdStyle={BreakLine}
                                            thStyle={BreakLine}
                                            dataFormat={(cell, row) => {
                                                const datos_anulacion = row.datos_fel
                                                    ? row.datos_fel
                                                          .datos_anulacion &&
                                                      row.datos_fel
                                                          .respuesta_anulacion
                                                        ? true
                                                        : false
                                                    : false;
                                                return (
                                                    <div>
                                                        {row.sin_factura ? (
                                                            <span className="text-muted font-weight-bold">
                                                                Recibo
                                                            </span>
                                                        ) : cell ? (
                                                            <div>
                                                                {cell.estado_factura == FACTURADO && (
                                                                    <span className="text-success font-weight-bold">
                                                                        Facturada
                                                                    </span>
                                                                )}
                                                                {cell.estado_factura == PROCESO && (
                                                                    <span className="text-warning font-weight-bold">
                                                                        En proceso
                                                                    </span>
                                                                )}
                                                                {cell.estado_factura == ANULADA && (
                                                                    <span className="text-danger font-weight-bold">
                                                                        Anulada
                                                                    </span>
                                                                )}
                                                                {cell.estado_factura == ERROR && !datos_anulacion && (
                                                                    <span className="text-danger font-weight-bold d-flex">
                                                                        Error
                                                                        <div className="compralo-img-popover">
                                                                            <i className="fa fa-eye text-danger ml-2"></i>
                                                                            <span>{row.datos_fel.errores_fel}</span>
                                                                        </div>
                                                                    </span>
                                                                )}
                                                                {cell.estado_factura == ERROR && datos_anulacion && (
                                                                    <span className="text-danger font-weight-bold">
                                                                        Error en anulación
                                                                    </span>
                                                                )}
                                                            </div>
                                                        ) : row.movimiento.tipo == 30 ? (
                                                            <span className="text-warning font-weight-bold">
                                                                Pendiente de facturación
                                                            </span>
                                                        ) : (
                                                            <span>-----</span>
                                                        )}
                                                    </div>
                                                );
                                            }}
                                        >
                                            Estado factura
                                        </TableHeaderColumn>
                                    )}
                                    {!estado && (
                                        <TableHeaderColumn
                                            datasort
                                            dataField="anulado_por"
                                            tdStyle={BreakLine}
                                            thStyle={BreakLine}
                                            dataFormat={(cell, row) => {
                                                return (
                                                    <div>
                                                        {cell ? (
                                                            <span>{cell}</span>
                                                        ) : (
                                                            <span>-----</span>
                                                        )}
                                                    </div>
                                                );
                                            }}
                                        >
                                            Anulado por
                                        </TableHeaderColumn>
                                    )}
                                    <TableHeaderColumn
                                        dataSort
                                        dataField="cliente__nombre"
                                        tdStyle={BreakLine}
                                        thStyle={BreakLine}
                                        dataFormat={(cell, row) => {
                                            return row.cliente;
                                        }}
                                    >
                                        Comprador
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataSort
                                        dataField="referencia"
                                        tdStyle={BreakLine}
                                        thStyle={BreakLine}
                                        dataFormat={(cell, row) => {
                                            return row.referencia;
                                        }}
                                    >
                                        Referencia
                                    </TableHeaderColumn>
                                    {/* <TableHeaderColumn
                                        dataField="id"
                                        tdStyle={BreakLine}
                                        thStyle={BreakLine}
                                        dataAlign="right"
                                        dataFormat={(cell, row) => {
                                            return (
                                                <div>
                                                    {row.movimiento.monto_efectivo > 0 && (
                                                        <h6><span className="badge badge-light">Efectivo</span></h6>
                                                    )}
                                                    {row.movimiento.monto_tarjeta > 0 && (
                                                        <h6><span className="badge badge-light">Tarjeta</span></h6>
                                                    )}
                                                    {row.movimiento.monto_cheque > 0 && (
                                                        <h6><span className="badge badge-light">Cheque</span></h6>
                                                    )}
                                                    {row.movimiento.monto_deposito > 0 && (
                                                        <h6><span className="badge badge-light">Depósito</span></h6>
                                                    )}
                                                </div>
                                            )
                                        }}
                                    >
                                        Pago con
                                    </TableHeaderColumn> */}
                                    <TableHeaderColumn
                                        dataSort
                                        dataField="movimiento__total_orginal"
                                        tdStyle={BreakLine}
                                        thStyle={BreakLine}
                                        dataAlign="right"
                                        dataFormat={(cell, row) => {
                                            return (
                                                <RenderMoneda
                                                    monto={
                                                        row.movimiento
                                                            .total_cobrar_pagar
                                                    }
                                                />
                                            );
                                        }}
                                    >
                                        Pago de
                                    </TableHeaderColumn>
                                    {/*----------- CONFIGURACION DE VENTAS AL CREDITO -----------*/}
                                    {conf_ventas_al_credito &&
                                    <TableHeaderColumn
                                        datasort
                                        dataField="cuenta_cobrar"
                                        tdStyle={BreakLine}
                                        thStyle={BreakLine}
                                        dataAlign="right"
                                        dataFormat={(cell, row) => {
                                            return (
                                                <RenderMoneda
                                                    monto={
                                                        row.cuenta_cobrar
                                                            ? row.cuenta_cobrar
                                                                .saldo
                                                            : 0
                                                    }
                                                />
                                            );
                                        }}
                                    >
                                        Saldo crédito
                                    </TableHeaderColumn>
                                    }
                                    {estado ? (
                                        <TableHeaderColumn
                                            dataField="id"
                                            isKey
                                            width="210px"
                                            dataAlign="center"
                                            tdStyle={{
                                                whiteSpace: "normal",
                                                overflow: "visible",
                                                padding: "6px 4px",
                                            }}
                                            dataFormat={(cell, row) => {
                                                if (
                                                    row.movimiento.tipo ===
                                                    tipo_movimientos.VENTA 
                                                ) {
                                                        return activeFormatter({
                                                            ver: "/reporte_ventas",
                                                            anular,
                                                            adicional: accionesReciboFactura,
                                                            datos_adicional: row,
                                                            anular_activo:
                                                                row.caja_activa,
                                                        })(cell, row);
                                                }  

                                                else if (
                                                    row.movimiento.tipo ==
                                                    tipo_movimientos.ABONO_CUENTA
                                                ) {
                                                    return activeFormatter({
                                                        anular,
                                                        adicional: accionReciboCaja,
                                                    })(cell, row);
                                                } else {
                                                    return activeFormatter({
                                                        anular,
                                                    })(cell, row);
                                                }
                                            }}
                                        >
                                            Acciones
                                        </TableHeaderColumn>
                                    ) : (
                                        <TableHeaderColumn
                                            dataField="id"
                                            isKey
                                            width="150px"
                                            dataAlign="center"
                                            dataFormat={(cell, row) => {
                                                if (
                                                    row.movimiento.tipo ===
                                                    tipo_movimientos.VENTA
                                                ) {
                                                    return activeFormatter({
                                                        ver: "/reporte_ventas",
                                                    })(cell, row);
                                                } else {
                                                    return <span></span>;
                                                }
                                            }}
                                        >
                                            Acciones
                                        </TableHeaderColumn>
                                    )}
                                    </BootstrapTable>
                                </div>
                            </LoadMask>
                        </div>
                    </div>
                    {
                        // RECIBO Y FACTURA
                        !factura_personalizada ? (
                            <div className="w100 print-only">
                                <PrintContainer name="reporteVentasReimpresion">
                                    {venta_impresion && (
                                        <Recibo
                                            sucursal={venta_impresion.sucursal}
                                            movimiento={venta_impresion}
                                            usuario={
                                                venta_impresion.usuario
                                                    .first_name
                                                    ? venta_impresion.usuario
                                                          .first_name
                                                    : ""
                                            }
                                            footerText={"TOTAL"}
                                            tipo={"Venta"}
                                            utiliza_fel={utiliza_fel}
                                        />
                                    )}
                                </PrintContainer>
                            </div>
                        ) : (
                            <div className="w100 print-only">
                                <PrintContainer
                                    name="reporteVentasReimpresion"
                                    className="impresion-venta d-table w-100"
                                >
                                    {venta_impresion &&
                                        venta_impresion.map(
                                            (factura, index) => {
                                                return (
                                                    <Factura
                                                        className={`${
                                                            index != 0
                                                                ? "salto-pagina"
                                                                : ""
                                                        }`}
                                                        key={index}
                                                        datos_venta={factura}
                                                        formato_factura={
                                                            formato_factura
                                                        }
                                                    />
                                                );
                                            }
                                        )}
                                </PrintContainer>
                            </div>
                        )
                    }

                    {/* RECIBO VENTA CREDITO */}
                    <div className="w100 print-only">
                        <PrintContainer
                            name="reporteVentasReimpresionReciboCaja"
                            className="impresion-venta d-table w-100"
                        >
                            {recibo_caja_impresion && (
                                <ReciboVentaCredito
                                    sucursal={recibo_caja_impresion.sucursal}
                                    movimiento={recibo_caja_impresion}
                                    utiliza_fel={utiliza_fel}
                                    conf_tipo_negocio={
                                        conf_tipo_negocio
                                            ? conf_tipo_negocio
                                            : {}
                                    }
                                />
                            )}
                        </PrintContainer>
                    </div>
                    <div className="w100 print-only">
                        <PrintContainer
                            name="impresionGeneral"
                            className="impresion-venta d-table w-100"
                        >
                            <ListadoPDF
                                data={
                                    data_movimientos_caja && data_movimientos_caja.data
                                        ? data_movimientos_caja.data
                                        : data
                                }
                                conf_tipo_negocio={conf_tipo_negocio}
                            />
                        </PrintContainer>
                    </div>
                </div>
            </div>
        );
    }
}

export default ListadoVentas;
